export default __webpack_public_path__ + "static/media/laptop_with_app.a99af476.svg";